import { Box, Stack } from '@mui/material';
import { ReactNode, cloneElement } from 'react';
import {
  SCREEN_HEADER_TITLE_MAX_CHARS,
  useScreenHeaderCompression,
} from '../hooks/useScreenHeaderCompression';
import { ScreenHeaderTagConfig } from '../screenHeader.types';
import { isBreadcrumbElement } from '../screenHeader.utils';
import { ScreenHeaderStatus } from './ScreenHeaderStatus';

const TRAILING_MIN_WIDTH = 120;

interface ScreenHeaderContentProps {
  breadcrumb: ReactNode;
  tags?: ScreenHeaderTagConfig[];
  trailing?: ReactNode;
}

export const ScreenHeaderContent = ({ breadcrumb, tags, trailing }: ScreenHeaderContentProps) => {
  const { contentRef, isTitleTruncated, isStatusCollapsed, isTrailingTruncated, isTrailingHidden } =
    useScreenHeaderCompression();

  const hasVisibleTrailing = Boolean(trailing) && !isTrailingHidden;

  const compressedBreadcrumb =
    isTitleTruncated && isBreadcrumbElement(breadcrumb)
      ? cloneElement(breadcrumb, { maxTitleChars: SCREEN_HEADER_TITLE_MAX_CHARS })
      : breadcrumb;

  return (
    <Stack
      ref={contentRef}
      direction="row"
      sx={{ alignItems: 'center', gap: 1.5, flex: 1, minWidth: 0, overflow: 'hidden' }}
    >
      <Box sx={{ minWidth: isTrailingHidden ? 0 : 'min-content' }}>{compressedBreadcrumb}</Box>
      <ScreenHeaderStatus tags={tags} collapse={isStatusCollapsed ? 'all' : 'none'} />
      {hasVisibleTrailing && (
        <Box
          sx={{
            flexShrink: isTrailingTruncated ? 1 : 0,
            minWidth: isTrailingTruncated ? TRAILING_MIN_WIDTH : 0,
            overflow: 'hidden',
          }}
        >
          {trailing}
        </Box>
      )}
    </Stack>
  );
};
